import { useState, useRef, useEffect } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";

export default function ContactUs(props: any) {
  const [isPreparedByEditing, setIsPreparedByEditing] = useState(false);
  const [preparedBy, setPreparedBy] = useState("");
  const [isWebsiteEditing, setIsWebsiteEditing] = useState(false);
  useEffect(() => {
    setPreparedBy(props.preparedBy);
  }, [props.preparedBy]);
  return (
    <div className="container p-0 border">
      <div className="w-100" style={{}}>
        <div
          className="position-relative text-center text-light small mt-5 border-top p-5 w-100"
          style={{ backgroundColor: `${props.primaryColor}`, color: "#fff" }}
        >
          <h6 className="pb-2 mt-3">
            <span className="border-bottom px-5 pb-1  text-20"> Contact Us</span>
          </h6>
          {props.isEditable && !props.isGeneratingPdf  ? (
            <>
              {!isPreparedByEditing ? (
                <i
                  className="fa fa-pencil text-12 ms-2 show-cursor d-flex flex-row justify-content-end mb-1"
                  title="Edit"
                  onClick={() => setIsPreparedByEditing(true)}
                />
              ) : (
                <span className="text-12  d-flex flex-row justify-content-end mb-1 ">
                  {isPreparedByEditing && props.saveLoading ? (
                    <div className="d-inline-flex align-items-center">
                      <AtkLoader />
                    </div>
                  ) : (
                    <i
                      className="fa fa-check mx-2 show-cursor text-success"
                      onClick={() => {
                        setIsPreparedByEditing(false);
                        props.onTemplateDetailsSave();
                      }}
                      title="Save"
                    />
                  )}
                  <i
                    className="fa fa-times show-cursor text-danger"
                    title="Cancel"
                    onClick={() => {
                      setIsPreparedByEditing(false);
                      props.onCancelTemplateDetailsToSave();
                    }}
                  />
                </span>
              )}
            </>
          ) : null}
          {isPreparedByEditing ? (
            <div className="">
              <InputTextarea value={preparedBy} onChange={props.onPreparedByChange} autoResize className="text-12 w-50 mt-1" />
            </div>
          ) : (
            <span className="text-white opacity-75 text-14">
              <p className="mb-1 w-75 mx-auto">{preparedBy} </p>
            </span>
          )}
          {/* <p className="pt-5 small mb-0 ">Email: your@domain.com</p> */}
          {props.isEditable && !props.isGeneratingPdf  ? (
            <>
              {!isWebsiteEditing ? (
                <i
                  className="fa fa-pencil text-12 ms-2 show-cursor d-flex flex-row justify-content-end mb-1"
                  title="Edit"
                  onClick={() => setIsWebsiteEditing(true)}
                />
              ) : (
                <span className="text-12 d-flex flex-row justify-content-end mb-1">
                  {isWebsiteEditing && props.saveLoading ? (
                    <div className="d-inline-flex align-items-center">
                      <AtkLoader />
                    </div>
                  ) : (
                    <i
                      className="fa fa-check mx-2 show-cursor text-success"
                      title="Save"
                      onClick={() => {
                        setIsWebsiteEditing(false);
                        props.onTemplateDetailsSave();
                      }}
                    />
                  )}
                  <i
                    className="fa fa-times show-cursor text-danger"
                    title="Cancel"
                    onClick={() => {
                      setIsWebsiteEditing(false);
                      props.onCancelTemplateDetailsToSave();
                    }}
                  />
                </span>
              )}
            </>
          ) : null}
          {isWebsiteEditing ? (
            <div>
              <InputText value={props.website} onChange={props.onWebsiteUrlChange} className="text-12 w-75 mt-1" />
            </div>
          ) : (
            <p className="small mb-0">Website: {props.website}</p>
          )}{" "}
          <div
            className="position-absolute  "
            style={{ width: "70%", height: "14px", top: "0px", left: "15%", backgroundColor: `${props.secondaryColor}` }}
          ></div>
        </div>
      </div>
    </div>
  );
}
